export default {
  badge: 'Insígnia',
  open: 'Obrir',
  close: 'Tancar',
  dismiss: 'Descartar',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Cancel·lar',
  },
  dataIterator: {
    noResultsText: 'Sense dades per mostrar',
    loadingText: 'Carregant...',
  },
  dataTable: {
    itemsPerPageText: 'Files per pàgina:',
    ariaLabel: {
      sortDescending: 'Ordre descendent.',
      sortAscending: 'Ordre ascendent.',
      sortNone: 'Sense ordenar.',
      activateNone: 'Premi per treure la ordenació.',
      activateDescending: 'Premi per ordenar descendent.',
      activateAscending: 'Premi per ordenar ascendent.',
    },
    sortBy: 'Ordenat per',
  },
  dataFooter: {
    itemsPerPageText: 'Elements per pàgina:',
    itemsPerPageAll: 'Tot',
    nextPage: 'Pàgina següent',
    prevPage: 'Pàgina anterior',
    firstPage: 'Primera pàgina',
    lastPage: 'Última pàgina',
    pageText: '{0}-{1} de {2}',
  },
  dateRangeInput: {
    divider: 'fins a',
  },
  datePicker: {
    itemsSelected: '{0} seleccionats',
    range: {
      title: 'Selecciona dates',
      header: 'Introdueix les dates',
    },
    title: 'Selecciona data',
    header: 'Introdueix la data',
    input: {
      placeholder: 'Introdueix la data',
    },
  },
  noDataText: 'Sense dades',
  carousel: {
    prev: 'Visualització prèvia',
    next: 'Visualització següent',
    ariaLabel: {
      delimiter: 'Diapositiva {0} de {1}',
    },
  },
  calendar: {
    moreEvents: '{0} més',
    today: 'Avui',
  },
  input: {
    clear: 'Esborra {0}',
    prependAction: 'Acció prefixada {0}',
    appendAction: 'Acció afegida {0}',
    otp: 'Si us plau, introdueix el caràcter OTP {0}',
  },
  fileInput: {
    counter: '{0} fitxers',
    counterSize: '{0} fitxers ({1} en total)',
  },
  fileUpload: {
    title: 'Arrossega i deixa anar els fitxers aquí',
    divider: 'o',
    browse: 'Explora fitxers',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Selecciona l’hora',
  },
  pagination: {
    ariaLabel: {
      root: 'Navegació de la pàgina',
      next: 'Pàgina següent',
      previous: 'Pàgina anterior',
      page: 'Ves a la pàgina {0}',
      currentPage: 'Pàgina actual, pàgina {0}',
      first: 'Primera pàgina',
      last: 'Última pàgina',
    },
  },
  stepper: {
    next: 'Següent',
    prev: 'Anterior',
  },
  rating: {
    ariaLabel: {
      item: 'Puntuació {0} de {1}',
    },
  },
  loading: 'Carregant...',
  infiniteScroll: {
    loadMore: 'Carrega més',
    empty: 'No hi ha més',
  },
  rules: {
    required: 'Aquest camp és obligatori',
    email: 'Si us plau, introdueix un correu electrònic vàlid',
    number: 'Aquest camp només pot contenir números',
    integer: 'Aquest camp només pot contenir valors enters',
    capital: 'Aquest camp només pot contenir lletres majúscules',
    maxLength: 'Has d’introduir un màxim de {0} caràcters',
    minLength: 'Has d’introduir un mínim de {0} caràcters',
    strictLength: 'La longitud del camp introduït no és vàlida',
    exclude: 'El caràcter {0} no està permès',
    notEmpty: 'Si us plau, tria almenys un valor',
    pattern: 'Format no vàlid',
  },
}
